
export { NoNftsCard } from "/home/runner/work/capsicum/capsicum/libs/socios-core/web/nfts/ui/no-nfts-card/NoNftsCard.tsx"